import isString from 'lodash/isString'
import flatten from 'lodash/flatten'

export const flattenStringMap = (map) => {
  if (isString(map)) return [map]

  return flatten(Object.keys(map).map((key) => flattenStringMap(map[key])))
}

export const factoryReducer = ({ registerType, unregisterType, resetType }, actionTypes, instance, identityFn) => {
  const unregister = (state, { meta }) => ({
    ...state,
    [identityFn(meta)]: undefined,
  })

  const handler = (state, action) => ({
    ...state,
    [identityFn(action.meta)]: instance(state[identityFn(action.meta)], action),
  })

  const reset = (state, action) => ({
    ...state,
    [identityFn(action.meta)]: instance(undefined, action),
  })

  const handlers = actionTypes.reduceRight(
    (acc, curr) => {
      acc[curr] = handler
      return acc
    },
    {
      [registerType]: handler,
      [unregisterType]: unregister,
      [resetType]: reset,
    },
  )

  const id = (state) => state

  const call = (fn = id, state, action) => fn(state, action)

  return (state = {}, action) => call(handlers[action.type], state, action)
}

export const getRegisteringReducer = ({ registerType, unregisterType, resetType }, reducer) => {
  const notRegisteredState = '##-notRegistered-@%&!@'

  const register = (state, action) => {
    if (state !== notRegisteredState) {
      return reducer(state, action)
    }
    return reducer(undefined, action)
  }

  const unregister = () => notRegisteredState

  const reset = (state, action) => {
    if (state !== notRegisteredState) {
      return reducer(undefined, action)
    }
    return state
  }

  const otherActions = (state, action) => {
    if (state !== notRegisteredState) {
      return reducer(state, action)
    }
    return state
  }

  const getHandler = (type) => {
    switch (type) {
      case registerType: {
        return register
      }
      case unregisterType: {
        return unregister
      }
      case resetType: {
        return reset
      }
      default:
        return otherActions
    }
  }

  return (state = notRegisteredState, action) => getHandler(action.type)(state, action)
}

export const getResettableReducer = (resetType, reducer) => {
  const reset = (state, action) => reducer(undefined, action)

  return (state, action) => (action.type === resetType ? reset : reducer)(state, action)
}
